import { __read } from "tslib";
import { SentryError } from './error';
/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */function () {
  /** Creates a new Dsn component */
  function Dsn(from) {
    if (typeof from === 'string') {
      this._fromString(from);
    } else {
      this._fromComponents(from);
    }
    this._validate();
  }
  /**
   * Renders the string representation of this Dsn.
   *
   * By default, this will render the public representation without the password
   * component. To get the deprecated private representation, set `withPassword`
   * to true.
   *
   * @param withPassword When set to true, the password will be included.
   */
  Dsn.prototype.toString = function (withPassword) {
    if (withPassword === void 0) {
      withPassword = false;
    }
    var _a = this,
      host = _a.host,
      path = _a.path,
      pass = _a.pass,
      port = _a.port,
      projectId = _a.projectId,
      protocol = _a.protocol,
      publicKey = _a.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
  };
  /** Parses a string into this Dsn. */
  Dsn.prototype._fromString = function (str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
      throw new SentryError(ERROR_MESSAGE);
    }
    var _a = __read(match.slice(1), 6),
      protocol = _a[0],
      publicKey = _a[1],
      _b = _a[2],
      pass = _b === void 0 ? '' : _b,
      host = _a[3],
      _c = _a[4],
      port = _c === void 0 ? '' : _c,
      lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
      path = split.slice(0, -1).join('/');
      projectId = split.pop();
    }
    if (projectId) {
      var projectMatch = projectId.match(/^\d+/);
      if (projectMatch) {
        projectId = projectMatch[0];
      }
    }
    this._fromComponents({
      host: host,
      pass: pass,
      path: path,
      projectId: projectId,
      port: port,
      protocol: protocol,
      publicKey: publicKey
    });
  };
  /** Maps Dsn components into this instance. */
  Dsn.prototype._fromComponents = function (components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
      components.publicKey = components.user;
    }
    this.user = components.publicKey || '';
    this.protocol = components.protocol;
    this.publicKey = components.publicKey || '';
    this.pass = components.pass || '';
    this.host = components.host;
    this.port = components.port || '';
    this.path = components.path || '';
    this.projectId = components.projectId;
  };
  /** Validates this Dsn and throws on error. */
  Dsn.prototype._validate = function () {
    var _this = this;
    ['protocol', 'publicKey', 'host', 'projectId'].forEach(function (component) {
      if (!_this[component]) {
        throw new SentryError(ERROR_MESSAGE + ": " + component + " missing");
      }
    });
    if (!this.projectId.match(/^\d+$/)) {
      throw new SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
    }
    if (this.protocol !== 'http' && this.protocol !== 'https') {
      throw new SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
    }
    if (this.port && isNaN(parseInt(this.port, 10))) {
      throw new SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
    }
  };
  return Dsn;
}();
export { Dsn };